import React, { useContext } from 'react';
import TableContext from './TableContext';
const AggregationTreeGroups = function AggregationTreeGroups(props) {
    const { trees } = props;
    const { prefixCls } = useContext(TableContext);
    if (trees.length > 1) {
        return (React.createElement("div", { className: `${prefixCls}-aggregation-groups` }, trees.map((tree, index) => React.createElement("div", { key: String(index), className: `${prefixCls}-aggregation-groups-tree` }, tree))));
    }
    return trees[0];
};
AggregationTreeGroups.displayName = 'AggregationTreeGroups';
export default AggregationTreeGroups;
